import { isAxiosError } from 'axios';
import { inject, injectable } from 'inversify';
import WalletService from 'src/features/pariWallet/data/service/WalletService';
import { GetAvailableSpentTransactionsParams } from 'src/features/pariWallet/data/service/WalletService.types';
import { GetAvailableSpentTransactionsUseCaseInterface } from 'src/features/pariWallet/domain/WalletUseCases.types';
import { AvailableSpentTransactionsResponse } from 'src/features/pariWallet/data/service/WalletService.types';

@injectable()
class GetAvailableSpentTransactionsUseCase
  implements GetAvailableSpentTransactionsUseCaseInterface
{
  @inject(WalletService) private walletService!: WalletService;

  async execute({
    userUuid,
    ordering,
    filters,
    walletUuid,
    limit = 2000,
    offset,
  }: GetAvailableSpentTransactionsParams): Promise<AvailableSpentTransactionsResponse> {
    try {
      const [availableResponse, spentResponse] = await Promise.all([
        this.walletService.getAvailableTransactions({
          userUuid,
          ordering,
          filters,
          walletUuid,
          limit,
          offset,
        }),
        this.walletService.getSpentTransactions({
          userUuid,
          ordering,
          filters,
          walletUuid,
          limit,
          offset,
        }),
      ]);

      return {
        available: availableResponse.data.results,
        spent: spentResponse.data.results,
      };
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return {
          available: [],
          spent: [],
        };
      }
      throw error;
    }
  }
}

export default GetAvailableSpentTransactionsUseCase;
